<template>
    <div class="select-place">
      <el-dialog ref="mapDialog" :visible.sync="showMapFlag" :closeOnClickModal="true" :showClose="true" :width="'666px'"
                 :destroy-on-close="false" :appendToBody="true" :customClass="''" :before-close="hideMap" @open="openHandle">
        <div slot="title"><i class="el-icon-location-outline"></i><span style="padding-left: 5px;color: #666666">选择该职位上班地点</span></div>
        <div class="map">
          <div class="search-box">
            <el-input id="search" size="small" placeholder="请输入地名" v-model="searchKeyword" class="input-with-select">
              <el-button slot="append" type="primary" icon="el-icon-search" @click="searchByHand"></el-button>
            </el-input>
          </div>
          <el-amap :vid="'amap-vue'"
                   :plugin="plugin"
                   :center="center"
                   class="map-content">
            <el-amap-marker vid="component-marker"
                            :position="item.location"
                            :events="item.events"
                            v-for="(item, index) of markers"
                            :key="index">
            </el-amap-marker>
            <el-amap-info-window
              :position="selectedPosition.location"
              :content="selectedPosition.content"
              :visible="selectedPosition.visible"
              :showShadow="true"
              :events="null"
              :offset="[0, -30]">
            </el-amap-info-window>
          </el-amap>
        </div>
      </el-dialog>
    </div>
</template>

<script>
export default {
  name: 'SelectMapPoint',
  props: ['showMapFlag', 'defaultKeyword'],
  data () {
    // let self = this
    return {
      address: null,
      searchKeyword: '',
      markers: [],
      center: [114.068801, 22.659153],
      selectedPosition: {
        location: [0, 0],
        content: '',
        visible: false
      },
      markerEvents: null,
      plugin: [
        {
          pName: 'ToolBar',
          events: {
            init (instance) {
              // console.log(instance)
            }
          }
        }, {
          pName: 'Scale',
          events: {
            init (instance) {
              // console.log(instance)
            }
          }
        }
      ]
    }
  },
  methods: {
    openHandle (e) {
      console.log(e)
    },
    hideMap (done) {
      this.$emit('hideSelectMap', this.selectedPosition)
      // done()
    },
    searchByHand () {
      if (this.searchKeyword.trim() !== '') {
        this.$api.getMapInfoByKeyword.params.keywords = this.searchKeyword.trim()
        this.$http.get(this.$api.getMapInfoByKeyword.url, this.$api.getMapInfoByKeyword.params).then(_ => {
          if (_ && _.pois.length > 0) {
            this.center = _.pois[0].location.split(',')
            this.markers = _.pois.map(item => {
              return {
                name: item.name,
                location: item.location.split(','),
                address: item.address,
                events: {
                  click: (e) => {
                    this.selectedPosition.visible = false
                    this.$nextTick(() => {
                      this.selectedPosition.location = item.location.split(',')
                      this.selectedPosition.content = `${item.name}[${item.address}]`
                      this.selectedPosition.visible = true
                    })
                  }
                }
              }
            })
            this.selectedPosition.visible = false
            this.$nextTick(() => {
              this.selectedPosition.location = this.markers[0].location
              this.selectedPosition.content = `${this.markers[0].name}[${this.markers[0].address}]`
              this.selectedPosition.visible = true
            })
          } else {
            this.$alert('未找到地址？搜索条件添加城市或者输入街道试试')
          }
        }).catch(e => {
          console.log(e)
        })
      }
    }
  },
  mounted () {
    this.searchKeyword = this.defaultKeyword
    this.searchByHand()
  }
}
</script>

<style scoped>
  /deep/ .el-dialog__body {
    padding: 0;
  }
  .map-content {
    height: 500px;
  }
  .map {
    position: relative;
  }
  .search-box {
    position: absolute;
    width: 300px;
    right: 10px;
    top: 10px;
    z-index: 2;
  }
</style>



// WEBPACK FOOTER //
// src/components/Recruit/SelectMapPoint.vue